import {
  GENERATE_SPEECH_DEPRECATED_ROUTE as INTERNAL_GENERATE_SPEECH_DEPRECATED_ROUTE,
  GENERATE_SPEECH_ROUTE as INTERNAL_GENERATE_SPEECH_ROUTE,
  GET_LISTENER_ROUTE as INTERNAL_GET_LISTENER_ROUTE,
  GET_SPEAKERS_DEPRECATED_ROUTE as INTERNAL_GET_SPEAKERS_DEPRECATED_ROUTE,
  GET_SPEAKERS_ROUTE as INTERNAL_GET_SPEAKERS_ROUTE,
  TRANSCRIBE_SPEECH_DEPRECATED_ROUTE as INTERNAL_TRANSCRIBE_SPEECH_DEPRECATED_ROUTE,
  TRANSCRIBE_SPEECH_ROUTE as INTERNAL_TRANSCRIBE_SPEECH_ROUTE,
} from '@internal/voice/routes';
import type { ServerRoute } from '../server-adapter/routes';

export const GET_SPEAKERS_ROUTE = INTERNAL_GET_SPEAKERS_ROUTE as unknown as ServerRoute;
export const GET_SPEAKERS_DEPRECATED_ROUTE = INTERNAL_GET_SPEAKERS_DEPRECATED_ROUTE as unknown as ServerRoute;
export const GENERATE_SPEECH_ROUTE = INTERNAL_GENERATE_SPEECH_ROUTE as unknown as ServerRoute;
export const GENERATE_SPEECH_DEPRECATED_ROUTE = INTERNAL_GENERATE_SPEECH_DEPRECATED_ROUTE as unknown as ServerRoute;
export const TRANSCRIBE_SPEECH_ROUTE = INTERNAL_TRANSCRIBE_SPEECH_ROUTE as unknown as ServerRoute;
export const TRANSCRIBE_SPEECH_DEPRECATED_ROUTE = INTERNAL_TRANSCRIBE_SPEECH_DEPRECATED_ROUTE as unknown as ServerRoute;
export const GET_LISTENER_ROUTE = INTERNAL_GET_LISTENER_ROUTE as unknown as ServerRoute;
